export const MEMORY_MAX_PAIR_CARDS = 12;
export const TIME_DELAY = 1000;
export const BASE_URL = "/react-games";
